import { JSXElementConstructor, memo } from "react";
import DotsSpinner from "../../spinner-dots.svg";
import LineSpinner from "../../spinner-line.svg";
import TrackSpinner from "../../spinner-track.svg";

export const redoSpinnerColor = ["black", "white"] as const;
export type RedoSpinnerColor = (typeof redoSpinnerColor)[number];
export const redoSpinnerSize = ["xs", "sm", "md", "lg", "xl"] as const;
export type RedoSpinnerSize = (typeof redoSpinnerSize)[number];

export const redoSpinnerStyle = ["track", "line", "dot"] as const;
export type RedoSpinnerStyle = (typeof redoSpinnerStyle)[number];

export const RedoSpinner = memo(function RedoSpinner({
  size = "sm",
  style = "track",
  color = "black",
  width: widthOverride,
  height: heightOverride,
}: {
  size?: RedoSpinnerSize;
  style?: RedoSpinnerStyle;
  color?: RedoSpinnerColor;
  /** When set, overrides the pixel width from `size`. */
  width?: number;
  /** When set, overrides the pixel height from `size`. */
  height?: number;
}) {
  const SvgElement = styleToSvg[style];
  const boxWidth = widthOverride ?? spinnerSizeToBoxSize[size];
  const boxHeight = heightOverride ?? spinnerSizeToBoxSize[size];

  return (
    <SvgElement
      data-arbiter="RedoSpinner"
      height={boxHeight}
      style={{ color }}
      width={boxWidth}
    />
  );
});

const styleToSvg: Record<RedoSpinnerStyle, JSXElementConstructor<any>> = {
  track: TrackSpinner,
  line: LineSpinner,
  dot: DotsSpinner,
};

const spinnerSizeToBoxSize: Record<RedoSpinnerSize, number> = {
  xs: 20,
  sm: 28,
  md: 48,
  lg: 56,
  xl: 64,
};
